// extracted by mini-css-extract-plugin
export default {"container":"styles_container__BULiJ","label":"styles_label__GMgm2"};